import { Component, Injectable, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { AttendanceService } from 'src/app/shared/services/attendanceservices/attendance.service';
import { PayrollService } from 'src/app/shared/services/payrollservices/payroll.service';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';

@Component({
  selector: 'app-pay-slip',
  templateUrl: './pay-slip.component.html',
  styleUrls: ['./pay-slip.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, LoaderComponent]

})
@Injectable({
  providedIn: 'root',
})
export class PaySlipComponent implements OnInit {
  public salary_detail: any = [];
  public user_detail: any = [];
  public showSpinner = false;
  public printingContent: any;
  public Data: any;
  public date = new Date();
  loanDetail: any;
  totalAmount: any;
  total_duration: any;
  paid_installment: any;
  remaining_amount: any;
  remaining_months: any;
  id: any
  selectedMode: any;
  datamode: any;
  userInfo: any;
  colormode: any;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public attendanceService: AttendanceService,
    public dashboardService: DashboardService,
    private sharedmode: SharedModeService,

    public payrollService: PayrollService
  ) {
    this.user_detail = JSON.parse(localStorage.getItem('user') || '');
    this.user_detail_detail();

  }
  ngOnInit(): void {
    this.salary_detail = JSON.parse(this.route.snapshot.queryParams.data);
    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });
  }
  toggleMode(mode: string) {
    this.datamode
    this.sharedmode.setMode(mode);
  }
  public openPDF(): void {
    this.Data = document.getElementById('salary-slip');
    html2canvas(this.Data, { scrollY: -window.scrollY }).then((canvas) => {
      const fileWidth = 208;
      const fileHeight = (canvas.height * fileWidth) / canvas.width;
      // let fileHeight = 500;
      const FILEURI = canvas.toDataURL('image/png');

      const PDF = new jsPDF('p', 'mm', 'letter');
      // let position = -150;
      PDF.addImage(FILEURI, 'PNG', 25, -15, fileWidth, fileHeight);

      PDF.save(`${this.user_detail.first_name} ${this.user_detail.last_name} ${this.salary_detail.month_char} Salary Slip.pdf`);

    });
  }

  async printPage() {
    this.printingContent = document.getElementById("salary-slip")?.innerHTML;
    const WinPrint = window.open();
    WinPrint?.document.write(this.printingContent);
    WinPrint?.document.close();
    WinPrint?.focus();
    await this.sleep(1000);
    WinPrint?.print();
    //WinPrint?.close();
  }

  sleep(ms: any) {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  }

  getPaySlipData(month: any, year: any) {
    this.payrollService.getPaySlip(month, year).then(value => {
      // this.temp = value.data;
    });
  }
  user_detail_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
      this.showSpinner = false;
    })

  }

  // loandetail(id: any) {
  //   this.showSpinner = true;


  //   this.payrollService.LoanReq(id).then((value) => {

  //     this.loanDetail = value.data
  //     this.totalAmount = this.loanDetail.total_amount
  //     this.total_duration = this.loanDetail.total_duration
  //     this.paid_installment = this.loanDetail.paid_months
  //     this.remaining_amount = this.loanDetail.remaining_amount
  //     this.remaining_months = this.loanDetail.remaining_months



  //     this.showSpinner = false;
  //   })
  // }
}
